/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCostcoRegistrationViewProps } from '../../../modules/hosports-costco-registration/./hosports-costco-registration';
import CostcoRegistrationForm from "./../../../baseComponents/costco-registration-form/./costco-registration-form";

export default (props: IHosportsCostcoRegistrationViewProps) => {
  let config = props.config;
    return (
        <CostcoRegistrationForm
          product={config.product}
          serialNumberLocation={config.serialNumberLocation}
          serialNumberLocationText={config.serialNumberLocationText}
          mailingListCta={config.mailingListCta}
        />
    );
};
